import { useMemo } from "react";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-solflare";
import { TrustWalletAdapter } from "@solana/wallet-adapter-trust";
import {
  WalletConnectWalletAdapter,
  WalletConnectWalletAdapterConfig,
} from "@solana/wallet-adapter-walletconnect";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";

const RPC_URL =
  process.env.REACT_APP_SOLANA_RPC_URL || "https://api.mainnet-beta.solana.com";
const WC_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || "";

export const SolanaProvider = ({ children }) => {
  const wallets = useMemo(() => {
    const list = [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      new TrustWalletAdapter(),
    ];
    if (WC_PROJECT_ID) {
      try {
        const wcConfig = {
          network: WalletAdapterNetwork.Mainnet,
          options: {
            projectId: WC_PROJECT_ID,
            metadata: {
              name: "JetDog Surf",
              description: "JetDog $JETDOG Play-to-Earn",
              url: typeof window !== "undefined" ? window.location.origin : "https://jetdog.app",
              icons: ["https://customer-assets.emergentagent.com/job_jetdog-token/artifacts/jaiary0q_erer.png"],
            },
          },
        };
        list.push(new WalletConnectWalletAdapter(wcConfig));
      } catch (e) {
        // WalletConnect optional - fail silently if misconfigured
      }
    }
    return list;
  }, []);

  return (
    <ConnectionProvider endpoint={RPC_URL}>
      <WalletProvider wallets={wallets} autoConnect={false}>
        {children}
      </WalletProvider>
    </ConnectionProvider>
  );
};

export default SolanaProvider;
